import axios from 'axios';

const api = axios.create({ baseURL: import.meta.env.VITE_API_URL });
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export interface TripPayload {
  date: string;
  driverId: string;
  truckId: string;
  companyId: string;
  bl_raw?: string | null;
  bl_numbers?: number[] | null;
  weight_t?: number | null;
  amount?: number | null;
  comment?: string | null;
}

export const getTrips = async (params: Record<string, any> = {}) => {
  const { data } = await api.get('/api/trips', { params });
  return data as { count: number; rows: any[] } | { rows: any[]; count: number };
};

export const createTrip = async (payload: TripPayload) => {
  const { data } = await api.post('/api/trips', payload);
  return data;
};

export const updateTrip = async (id: string, payload: Partial<TripPayload>) => {
  const { data } = await api.patch(`/api/trips/${id}`, payload);
  return data;
};

export const deleteTrip = async (id: string) => {
  await api.delete(`/api/trips/${id}`);
};

export const exportTrips = async (params: Record<string, any> = {}, file: 'csv'|'xlsx'|'pdf' = 'csv') => {
  const res = await api.get('/api/trips/export', { params: { ...params, file }, responseType: 'blob' });
  const blob = new Blob([res.data], { type: res.headers['content-type'] || 'application/octet-stream' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  const filename = (res.headers['content-disposition'] || '').split('filename=')[1]?.replace(/"/g,'') || `trips.${file}`;
  a.href = url; a.download = filename; a.click(); URL.revokeObjectURL(url);
};
